import React from 'react'

import { StyledSupport } from './Support.style'
import { TabSupport } from './Support.constant';
// import "../assets/style/support.css"
import SupportVideo from "../../../assets/images/support.mp4"


export default function Support() {

  const [value, setValue] = React.useState(0);

  const handleChange = (newValue) => {
    setValue(newValue);

  };

  return (
    <StyledSupport>
      <header className='support'>
        <div className='shadow'></div>
        <video className='support-video' src={SupportVideo} autoPlay loop muted ></video>
        <div className='container'>
          <div className='support-main'>
            <h1>Support</h1>
            <p>The most easy-to-use ELD device and application</p>
          </div>
        </div>
      </header>

      <section className='tab-section'>
        <div className='container'>
          <div className='tab-main'>
            {
              TabSupport.map((item) => (
                <div className={`tab-item ${item.id === value ? "active" : ""}`} key={item.id} onClick={() => handleChange(item.id)}>
                  {item.icon}
                  <h3>{item.text}</h3>
                </div>
              ))
            }
          </div>
          <div className='tab-body'>
            {TabSupport.map((item) => (item.id === value) ? item.body : "")}
          </div>
        </div>
      </section>

    </StyledSupport>
  )
}


